import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Stack, Box, CardActionArea } from '@mui/material';
import { FaUsers } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { fetchAllMembers } from '../../controllers/memberManagementController';

const ÜyelerKartı = () => {
  const navigate = useNavigate();
  const [totalMembers, setTotalMembers] = useState(null);
  const [loadingMembers, setLoadingMembers] = useState(false);

  useEffect(() => {
    let active = true;
    setLoadingMembers(true);
    fetchAllMembers({ pageNumber: 1, pageSize: 10000 })
      .then(({ data }) => {
        if (!active) return;
        const count = Array.isArray(data) ? data.length : 0;
        setTotalMembers(count);
      })
      .catch((e) => {
        if (!active) return;
        console.error('Üyeler sayısı alınamadı:', e);
        setTotalMembers(null);
      })
      .finally(() => {
        if (active) setLoadingMembers(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <Card sx={{ border: '1px solid #f1f1f1', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)', borderRadius: '8px' }}>
      <CardActionArea onClick={() => navigate('/members')}>
        <CardContent sx={{ p: 2.5 }}>
          <Stack>
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: '50%',
                backgroundColor: '#f5f5f5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 3,
              }}
            >
              <FaUsers style={{ fontSize: '20px', color: '#0E4D94' }} />
            </Box>
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#666666', mb: .5 }}>
              Üyeler
            </Typography>
            <Typography sx={{ fontSize: '28px', fontWeight: 700, color: '#444444' }}>
              {loadingMembers ? '-' : (totalMembers !== null ? totalMembers : '-')}
            </Typography>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ÜyelerKartı;
